import { AnswserQuestion } from "@/models/questions.model";
import { DustLevel, TypeOfContainement } from "@/models/settings.model";
import { ElementaryZone } from "@/models/site.model";

/**
 * Calculate zones total volume
 */
export function calculateTotalVolume(elementaryZones: ElementaryZone[]): number {
  const volumes = elementaryZones.map((e) => Number(e.volume));
  return reduceNumberArray(volumes);
}

/**
 * Calculate Site Level
 * @param dustLevel represents the current dust level in F/m^3
 */
export function calculateSiteLevel(dustLevel: number): number {
  return dustLevel < DustLevel.Level2 ? 2 : 3;
}

/**
 * Calculate minimal renewal rate
 * @param dustLevel represents the current dust level in F/m^3
 */
export function calculateMinimalRenewalRate(dustLevel: number): number {
  return dustLevel < DustLevel.Level1
    ? 6
    : dustLevel < DustLevel.Level2
    ? 15
    : dustLevel < DustLevel.Level3
    ? 20
    : 20;
}

/**
 * Calculate containement type according to questions answers
 */
export function calculateContainementType(questions: AnswserQuestion[]): TypeOfContainement {
  // set base weight according to question index
  const weight = questions.map((answer, index) => {
    return {
      value: answer.value,
      weight: questions.length - index,
    };
  });

  let totalWeight = 0;

  /**
   * foreach question if question answer is false
   * then add current question weight to totalWeight
   * and if last question answer is false then double totalWeight
   */
  weight.forEach((questionWeight, index) => {
    if (!questionWeight.value) {
      totalWeight += questionWeight.weight;
      if (index > 0 && !weight[index - 1].value) {
        totalWeight += totalWeight;
      }
    }
  });
  return totalWeight <= 1
    ? TypeOfContainement.TYPEIV
    : totalWeight <= 4
    ? TypeOfContainement.TypeIII
    : totalWeight == 22
    ? TypeOfContainement.TypeI
    : TypeOfContainement.TypeII;
}

/**
 * Sum all value of number array
 */
export function reduceNumberArray(numbers: number[]): number {
  return numbers.reduce((previousValue, currentValue) => previousValue + currentValue, 0);
}
